export const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

export function monthLabel(month, year) {
    return `${MONTH_NAMES[month - 1] ?? month} ${year}`;
}
